import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import { isEmpty, sortBy, compose, prop } from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import styled from "styled-components";
import moment from "moment";
import NestedGrid from "./listBikeHistoryGrid";
const Card = styled.div(props => ({
  padding: "1em",
  backgroundColor: props.color,
  boxShadow: "rgb(245,157,29) 0px 1px 3px, rgb(250,228,195)  0px 1px 2px",
  marginTop: "0.5em"
}));

class ListItemHistory extends Component {
  state = {
    error: false,
    showDialog: false
  };

  renderVehicle = data => {
    return (
      <React.Fragment>
        <Grid container spacing={8}>
          <Grid item xs={12} sm={12}>
            <b>Remaining activity:</b>
          </Grid>
        </Grid>
        <NestedGrid
          events={sortBy(
            compose(
              moment,
              prop("date1")
            ),
            data
          )}
        />
      </React.Fragment>
    );
  };

  render() {
    if (isEmpty(this.props.itemData)) {
      return <LinearProgress />;
    }

    return <Card>{this.renderVehicle(this.props.itemData)}</Card>;
  }
}

export default ListItemHistory;



// WEBPACK FOOTER //
// ./src/components/listItemHistory.js